import TextStyles from "../../components/Elements/TextStyles/TextStyles";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as GreenEye } from "../../assets/svgs/greenEye.svg";
import { Tables } from "../../components/Elements/Tables/Tables";
import CardsBorder from "../../components/Cards/CardsBorder";
import SearchBar from "../../components/Elements/Search/SearchBar";
import { Button, Spin, Alert } from "antd";
import { ReactComponent as FilterIcon } from "../../assets/svgs/filter-icon.svg";
import CustomSwitch from "../../components/Elements/CustomSwitch/CustomSwitch";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLicenseCustomers } from "../../redux/license/licenseSlice";
import { useDebounce } from "../../hooks/debouncing";
const License = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    customers,
    totalCustomers,
    limit,
    skip,
    loadingLicenseCustomers,
    error,
  } = useSelector((state) => state.license);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Customer Name", key: "customerName" },
      { label: "Organization Name", key: "groupName" },
      { label: "User ID", key: "userId" },
      { label: "Action", key: "action" },
    ],
    [],
  );
  //---API CALL--------------
  useEffect(() => {
    dispatch(
      fetchAllLicenseCustomers({
        pageNo: page,
        limit,
        sort: "-createdAt",
        search: debouncedSearch,
      }),
    );
  }, [dispatch, page, debouncedSearch, limit]);

  const tableRows = useMemo(() => {
    return customers.map((row, index) => ({
      ...row,
      serial: (
        <div className="text-center font-light">{skip + index + 1}</div>
      ),
      customerName: (
  <div className="text-center font-light whitespace-normal break-words">
    {row.organization?.name || row.name}
  </div>
),

groupName: (
  <div className="text-center font-light whitespace-normal break-words">
    {row.billing?.organizationName ||
      row.organization?.name ||
      row.location ||
      "-"}
  </div>
),
      userId: <div className="text-center font-light">{row.userId}</div>,
      action: (
        <div className="flex gap-2 justify-center items-center">
          <button
            type="button"
            className="cursor-pointer"
            onClick={() =>
              navigate(`/license/license-detail-page`, {
                state: {
                  customerId: row._id,
                  userId: row.userId,
                  projectId: row.offset_id,
                  userName: row.name,
                },
              })

              
            }

            
            aria-label={`Open license details for ${row.name}`}
          >
            <GreenEye />
          </button>
          <CustomSwitch
            checked={row.status === "Active"}
            onChange={(val) => {
              console.log("Status changed", val);
            }}
          />
        </div>
      ),
    }));
  }, [customers, navigate, skip]);

  return (
    <div
      style={{ padding: "40px", backgroundColor: "#fff" }}
      className="h-screen"
    >
      <div>
        <div>
          <div
            className="flex justify-end  text-xs"
            style={{ fontFamily: "Calibri" }}
          >
            <p>Home</p>
            <span> / </span>
            <TextStyles color="gradient"> License</TextStyles>
          </div>
          <div className="flex items-center  gap-2 text-xl  font-bold">
            {/* <Back /> */}
            <div className="pt-4 px-2">
              <TextStyles color="gradient"> License</TextStyles>
            </div>
          </div>
        </div>
        <CardsBorder>
          <div className="flex justify-between mb-4 px-6">
            <div className="flex gap-4">
              <div
                style={{
                  background: "#B6D4D933",
                  height: "40px",
                }}
                className="px-4   border border-gray-300 rounded-md text-gray-400 text-base font-light"
              >
                <p
                  style={{
                    fontFamily: "Calibri",
                    fontWeight: "300",
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0%",
                  }}
                  className="pt-2"
                >
                  TOTAL CUSTOMERS {totalCustomers}
                </p>
              </div>
              <SearchBar
                width="300px"
                onSearch={(value) => {
                  setSearch(value);
                  setPage(1);
                }}
              />
            </div>
            {/* <div className="flex gap-4">
              <Button
                // onClick={() => setFilterOpen(true)}
                type="secondary"
                style={{
                  background: "#B6D4D9",
                  border: "solid 1px #06513D",
                }}
                className="text-[14px] text-[#06513D] bg-[#E6EDEB] hover:!bg-[#F8F8F8] font-normal px-4 py-6"
              >
                <FilterIcon /> FILTER
              </Button>
            </div> */}
          </div>
          {error && (
            <div className="px-6 pb-4">
              <Alert type="error" message={error} showIcon />
            </div>
          )}
          {loadingLicenseCustomers ? (
            <div className="flex justify-center py-16">
              <Spin size="large" />
            </div>
          ) : (
            <Tables
              data={tableRows}
              headers={headers}
              pageSize={limit}
              total={totalCustomers}
              current={page}
              onChange={(nextPage) => setPage(nextPage)}
            />
          )}
        </CardsBorder>
      </div>
    </div>
  );
};

export default License;
